import React from "react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const ActionBoxCTA = ({
	icon,
	heading,
	content,
	button,
	buttonIcon,
	link,
	linkTarget,
	tag,
	className,
}) => {
	useEffect(() => {
		AOS.init({ duration: 1200, delay: 100 });
	}, []);

	return (
		<a href={link} target={linkTarget} className={CSS.Container}>
			<div className={`${CSS.ActionBox} ${className}`}>
				<li className="material-symbols-round icon">{icon}</li>
				<h3>
					{heading}
					{tag && <span>{tag}</span>}
				</h3>
				{content}
				<Button variant="HeroButton" leftIcon={buttonIcon}>
					{button}
				</Button>
			</div>
		</a>
	);
};

export default ActionBoxCTA;
